module.exports = __webpack_public_path__ + "6db4d01859c4741a481e2d93e34e0355.svg";


//////////////////
// WEBPACK FOOTER
// ../images/admin/approval_queues/icons/icon-greencheck.svg
// module id = 985
// module chunks = 69